'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionDetails', ['$scope', 'IPInspections', function ($scope, IPInspections) {
        $scope.resetInspection();
        $scope.saving = false;

        $scope.save = function () {
            $scope.saving = true;
            IPInspections.save($scope.inspection, false, true).then(function (inspection) {
                $scope.saving = false;
                $scope.setMasterInspection(inspection);
            })
        }
    }])
;